import { ModuleWithProviders, NgModule } from '@angular/core';
import { EvaluationInstanceDetailComponent } from '@masar/features/evaluate/components/evaluation-instance-detail/evaluation-instance-detail.component';
import { EvaluationInstanceListComponent } from '@masar/features/evaluate/components/evaluation-instance-list/evaluation-instance-list.component';
import { EvaluateService } from '@masar/features/evaluate/services/evaluate.service';
import { CommonModule } from '@angular/common';
import { MasarModule } from '@masar/features/masar/masar.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@masar/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    EvaluationDashboardPageComponent,
    EvaluationStatisticsComponent,
} from '@masar/features/evaluate/components';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { EvaluationGuidePreviewComponent } from '@masar/features/evaluate/components/evaluation-guide-preview/evaluation-guide-preview.component';
import { EvaluationRecordRangeLabelPipe } from '@masar/features/evaluate/pipes/evaluation-record-range-label.pipe';
import { EvaluationLegacyValueLabelPipe } from '@masar/features/evaluate/pipes/evaluation-legacy-value-label.pipe';
import { EvaluationInstancePortalComponent } from '@masar/features/evaluate/components/evaluation-instance-portal/evaluation-instance-portal.component';
import { RubricEvaluationInstanceDetailComponent } from '@masar/features/evaluate/components/rubric-evaluation-instance-detail/rubric-evaluation-instance-detail.component';

@NgModule({
    declarations: [
        EvaluationInstanceDetailComponent,
        EvaluationInstanceListComponent,
        EvaluationInstancePortalComponent,
        RubricEvaluationInstanceDetailComponent,
        EvaluationStatisticsComponent,
        EvaluationDashboardPageComponent,
        EvaluationGuidePreviewComponent,
        EvaluationRecordRangeLabelPipe,
        EvaluationLegacyValueLabelPipe,
    ],
    imports: [
        CommonModule,
        MasarModule,
        TranslateModule,
        SharedModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        NgSelectModule,
    ],
    exports: [
        EvaluationInstanceListComponent,
        EvaluationStatisticsComponent,
        EvaluationDashboardPageComponent,
    ],
})
export class EvaluateModule {
    public static forRoot(): ModuleWithProviders<EvaluateModule> {
        return { ngModule: SharedModule, providers: [EvaluateService] };
    }
}
